import React from "react";
import styled, { keyframes } from "styled-components";

const squareSlider = keyframes`
  0% {
    transform: rotateZ(0deg);
  }
  25% {
    transform: rotateZ(0deg);
  }
  50% {
    transform: rotateZ(180deg);
  }
  75% {
    transform: rotateZ(270deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
`;

const Warrper = styled.div<{ width: string; height: string }>`
  --width-square: ${({ width }) => width && width};
  --height-square: ${({ height }) => height && height};

  .squareGroup {
    width: var(--width-square);
    height: var(--height-square);
    position: relative;
  }
  .squareBefor,
  .squareAffter {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0%;
    top: 0%;
  }
  .squareAffter {
    transform: rotateZ(215deg);
  }
  .square {
    width: 50%;
    height: 50%;
    background-color: #f7da57;
    position: absolute;
    left: 0px;
    bottom: 0%;
  }
  .squareBeforSlider {
    animation-name: ${squareSlider};
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
  .squareAffterSlider {
    animation-name: ${squareSlider};
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-delay: -1s;
  }
`;

interface SquareSlider {
  width: string;
  height: string;
}

const Square: React.FC<SquareSlider> = ({ width, height }) => {
  return (
    <Warrper width={width} height={height}>
      <div className="squareGroup">
        <div className="squareBefor squareBeforSlider">
          <div className="square"></div>
        </div>
        <div className="squareAffter squareAffterSlider">
          <div className="square"></div>
        </div>
      </div>
    </Warrper>
  );
};

export default React.memo(Square);
